/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, createAsyncThunk, createSlice, } from "@reduxjs/toolkit";
import { ApplicationService } from "../../service/ApplicationService";
// Define the selectApplication action
export const selectApplication = createAction("application/selectApplication");
const initialState = {
    loading: false,
    applications: [],
    selectedApplication: {},
    applicationsByWorkSpaceId: []
};
const action = {
    createApplication: createAsyncThunk("application/create", async (_payload, thunkAPI) => {
        try {
            return (await ApplicationService.create(thunkAPI, _payload.data)).data;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }),
    updateApplication: createAsyncThunk("application/update", async (payload, thunkAPI) => {
        try {
            return (await ApplicationService.update(thunkAPI, payload.data)).data;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }),
    readApplication: createAsyncThunk("application/read", async (_, thunkAPI) => {
        return (await ApplicationService.read(thunkAPI)).data;
    }),
    deleteApplication: createAsyncThunk("application/delete", async (payload, thunkAPI) => {
        return (await ApplicationService.delete(thunkAPI, payload.data)).data;
    }),
    readByWorkspaceId: createAsyncThunk("application/readByWorkspaceId", async (payload, thunkAPI) => {
        return (await ApplicationService.readByWorkspaceId(thunkAPI, payload)).data;
    }),
};
const slice = createSlice({
    name: "application",
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setApplications(state, action) {
            state.applications = action.payload;
        },
        selectedApplication(state, action) {
            state.selectedApplication = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.createApplication.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.createApplication.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else
                action.meta.arg.onError?.(action.payload);
        }).addCase(action.updateApplication.pending, (state) => {
            state.loading = true;
        }).addCase(action.updateApplication.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else
                action.meta.arg.onError?.(action.payload);
        }).addCase(action.deleteApplication.pending, (state) => {
            state.loading = true;
        }).addCase(action.deleteApplication.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        })
            .addCase(action.readApplication.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.readApplication.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.responseCode === "00") {
                state.applications = action.payload.data;
            }
        })
            .addCase(action.readByWorkspaceId.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.readByWorkspaceId.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.responseCode === "00") {
                state.applicationsByWorkSpaceId = action.payload.data;
            }
        })
            .addCase(selectApplication, (state, action) => {
            state.selectedApplication = action.payload;
        });
    },
});
export const application = {
    reducer: slice.reducer,
    action,
    mutation: slice.actions,
};
